/* eslint-disable jsx-a11y/anchor-is-valid */
import { MenuComponent } from '_metronic/assets/ts/components'
import clsx from 'clsx'
import { useEffect } from 'react'
import { PileHoleTableRow } from './pileHoleMapper'

export interface ActionCellProps {
  row: PileHoleTableRow
  onClickPrebore: (row: PileHoleTableRow) => void
  onContinueDriving?: (pileHoleId: number) => void
}

const ActionCell: React.FC<ActionCellProps> = ({
  row,
  onClickPrebore,
  onContinueDriving,
}) => {
  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const isInProgress = row.status === 'in-progress'

  return (
    <>
      <a
        className='btn btn-icon btn-custom btn-active-light rounded-circle'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'>
        <img src='/media/icons/dots-vertical.png' alt='Dot Vertical Icon' width={20} height={20} />
      </a>
      <div
        className={clsx(
          'menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-175px py-4'
        )}
        data-kt-menu='true'>
        {isInProgress && onContinueDriving && (
          <div className='menu-item px-3' data-kt-menu-dismiss='true'>
            <a
              className='menu-link px-3 d-flex align-items-center flex-row'
              onClick={() => onContinueDriving(row.id)}>
              <div className='text-kumopack-grey-700' style={{ marginTop: '0.1rem' }}>
                ดำเนินการต่อ
              </div>
            </a>
          </div>
        )}
        <div className='menu-item px-3' data-kt-menu-dismiss='true'>
          <a
            className='menu-link px-3 d-flex align-items-center flex-row'
            onClick={() => onClickPrebore(row)}>
            <div className='text-kumopack-grey-700' style={{ marginTop: '0.1rem' }}>
              ตั้งค่า prebore
            </div>
          </a>
        </div>
      </div>
    </>
  )
}

export default ActionCell
